import { IconButton, Typography, TextField, Accordion, AccordionSummary, AccordionDetails, Select, MenuItem } from '@mui/material';
import { rewardsTxType } from '../../../util/DataObject';
import { Close, ExpandMore } from '@mui/icons-material';
import { FlexGrid } from '@albo-ui/core'

export const CouponDetail = ({ data, onHandleChangeConfig, deleteCoupon }) => {

    return (
        <FlexGrid container style={{ overflowY: 'auto', display: "block"}} fullWidth>
            {
                data && data.map((item, index) => {
                    return <Accordion key={`coupon-form-${index}`} sx={{width: '100%', p: 0}}>
                        <AccordionSummary sx={{alignItems: 'center', m: 0, p: 0}} expandIcon={<ExpandMore/>}>
                            <IconButton title='Eliminar' onClick={deleteCoupon.bind(this, index)}><Close/></IconButton>
                            <Typography fontWeight="600" fontFamily="Muli,sans-serif" color="#3E3E42" fontSize="1rem" component={'span'} mt={1} p={0}>
                                Cupón {index + 1}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{p: 0}}>
                        <FlexGrid container direction="column" alignItems='flex-start' spacing={2}>
                            <FlexGrid container spacing={2} fullWidth>
                                <TextField value={item["title"]} onInput={onHandleChangeConfig.bind(this, "title", "")} label="Titulo" color="secondary" fullWidth/>
                                <TextField value={item["description_coupon"]} onInput={onHandleChangeConfig.bind(this, "description_coupon", "")} label="Descripción" color="secondary" fullWidth/>
                            </FlexGrid>
                            <FlexGrid container spacing={2} fullWidth>
                                <TextField value={item["value_coupon"]} onInput={onHandleChangeConfig.bind(this, "value_coupon", "")} label="Valor" color="secondary" fullWidth/>
                                <Select MenuProps={{style: {zIndex: 35001}}} value={item["type"] || -1} onChange={onHandleChangeConfig.bind(this, "type", "")} color='secondary' fullWidth>
                                    <MenuItem value={'-1'} disabled>Tipo</MenuItem>
                                    {rewardsTxType.map((t) => {
                                        return <MenuItem key={t.key} value={t.key}>{t.label}</MenuItem>
                                    })}
                                </Select>
                            </FlexGrid>
                            <FlexGrid container spacing={2} fullWidth>
                                <TextField value={item["icon_enabled_url"]} onInput={onHandleChangeConfig.bind(this, "icon_enabled_url", "")} label="Icono activo" color="secondary" fullWidth/>
                                <TextField value={item["icon_disabled_url"]} onInput={onHandleChangeConfig.bind(this, "icon_disabled_url", "")} label="Icono inactivo" color="secondary" fullWidth/>
                            </FlexGrid>
                            <FlexGrid container spacing={2} fullWidth>
                                <TextField value={item["url_detail"]} onInput={onHandleChangeConfig.bind(this, "url_detail", "")} label="Detalle URL" color="secondary" fullWidth/>
                            </FlexGrid>
                        </FlexGrid>
                        </AccordionDetails>
                    </Accordion>
                })}
        </FlexGrid>
    )
}